import { IMasterLegalEntity } from "modules/Utilities/ConfigureAgreement/MasterLegalEntity/type/MasterLegalEntityTypeInterface";

import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/MasterLegalEntity";

//Add MasterLegalEntity
export const addMasterLegalEntity = async (newData: IMasterLegalEntity) => {
  const { data } = await axios.post(`${api_base_url}`, newData);
  return data;
};

// //Delete MasterLegalEntity
export const deleteMasterLegalEntity = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/MasterLegalEntity`, {
    data: ids,
  });
  return data;
};

// //Update MasterLegalEntity
export const updateMasterLegalEntity = async (updatedMasterLegalEntity) => {
  const { data } = await axios.put(`${api_base_url}`, updatedMasterLegalEntity);
  return data;
};

export const getMasterLegalEntities = () => {
  return axios.get(`${api_base_url}/GetMasterLegalEntities`).then((res) => {
    return res;
  });
};
